import React from 'react';

import '../../sass/components/charts/TopPerformingView.scss';

export default class TopPerformingView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render = () => {
    const data = this.props.data || [];
    const maxCount = data.reduce((res, cur) => Math.max(res, cur.count), 0);
    return (
      <div className='topPerformingView'>
        {data.map((item, i) =>
          <div key={i} className='topPerformer'>
            <div className='performerName'>{item.name}</div>
            <div className='valueContainer'>
              <div
                className='performerValue'
                style={{width: `${item.count / maxCount * 100}%`}}
              >{item.count}</div>
            </div>
          </div>
        )}
      </div>
    )
  }

}
